<app-page-heading [key]="'nav.user-dashboard.blue-tracking-managers'"></app-page-heading>

<section class="container summary-panel">
    <div class="row">
        <div class="col-md-12">
            <app-data-filters class="pull-left" #dataFilters [disableSearch]="emailFilter.minLengthInvalid">
                <app-data-filter-group>
                    <app-data-filter-input
                        #emailFilter
                        [labelKey]="'user-dashboard.users.list.filters.email.label'"
                        [(model)]="filters.email"
                        [minLength]="3"
                        [helperKey]="'user-dashboard.users.list.filters.email.helper'"
                        [placeholderKey]="'user-dashboard.users.list.filters.email.placeholder'"></app-data-filter-input>
                </app-data-filter-group>
            </app-data-filters>

            <button class="btn btn-primary btn-lg pull-right" (click)="addOverdueManagerRoleToExistingUser(addOverdueManagerModal)">
                <span class="fa fa-plus"></span>
                <span [i18n]="'user-dashboard.users.blue-tracking-managers.list.buttons.add-overdue-manager'"></span>
            </button>
            <br>
        </div>
    </div>

    <br>

    <div class="row">
        <div class="col-md-12">
            <div class="ibox float-e-margins">
                <p [i18n]="'user-dashboard.users.blue-tracking-managers.list.role-explanation'"></p>
                <div class="ibox-content no-padding">
                    <app-user-table #userTable
                                    [showDelete]="true"
                                    [showEdit]="false"
                                    [showStatus]=false
                                    [loadPage]="loadPage"
                                    [filtersComponent]="dataFilters"
                                    (filtersReset)="filters.reset()"
                                    [(filters)]="filters"
                                    (delete)="openRoleRemovalConfirmationPopup(confirmRoleRemovalModal, $event)">
                    </app-user-table>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #addOverdueManagerModal>
    <p [i18n]="'user-dashboard.users.blue-tracking-managers.add-role-modal.explanation'"></p>
    <ng-select [items]="chepManagers"
               [bindLabel]="'email'"
               [hideSelected]="true"
               [multiple]="true"
               [(ngModel)]="selectedChepManagers">
    </ng-select>
</ng-template>

<ng-template #confirmRoleRemovalModal>
    <span [i18n]="'user-dashboard.users.blue-tracking-managers.remove-role-modal.explanation'"></span>
</ng-template>
